var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17 19",
    width: 17,
    height: 19,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Tiktok") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #ffffff } \n\t")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    className: "s0",
    d: "m12.1 0c-0.2 1.5 1.4 4 3.3 4.5 0.2 0 0.5 0.1 0.7 0.2 0.3 0 0.6 0 0.9 0.1v3h-0.5c-1.5-0.2-2.9-0.6-4.4-1.6v7.5c-0.5 3.5-3.4 5.3-6.1 5.3-0.6 0-0.6 0-1.4-0.2-1.4-0.2-3.6-1.8-4.1-3.3-0.1-0.2-0.2-0.4-0.2-0.5-0.1-0.3-0.2-0.5-0.2-0.7-0.1-0.2-0.1-0.5-0.1-0.6v-1.1c0.6-3.6 3.3-5.3 6-5.3 0.1 0 0.7 0 0.9 0v3.1c-0.2-0.1-0.6-0.1-0.9-0.1-1.6 0-2.8 1.2-2.8 2.8 0 1.6 1.3 2.9 2.8 2.9 1.3 0 2.7-0.9 3-2.6v-13.4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/Tiktok.4a0fb46642471cc664ad3658d31ac8cd.svg";
export { ForwardRef as ReactComponent };